import store from '../redux/store';
import debounce from '../utils/debounce';
import {getComponentById, getDeckByComponentId, getSlideIndex} from '../selectors';
import {setSlideIndex} from '../actions/slides';

const componentIdRegex = /^component-(.+)$/;
const initialEntry = {intersectionRatio: 0};
const callbacks = new WeakMap();
let activeSlideIndex;

const isIntersecting = entry => entry.isIntersecting;
const getComponentId = el => el.id.match(componentIdRegex)[1];

function mostIntersecting(top, entry) {
  return entry.intersectionRatio > top.intersectionRatio ? entry : top;
}

function callEntry(entry) {
  const callback = callbacks.get(entry.target);

  if (!callback) {
    throw new Error('attempted to call unregistered callback');
  }

  callback(entry);
}

const debouncedSetActiveIndex = debounce(() => setSlideIndex(activeSlideIndex)(store.dispatch, store.getState), 100);

function syncSlideIndex(entry) {
  const id = getComponentId(entry.target);

  const state = store.getState();
  const component = getComponentById(state, {id});

  if (Object.keys(component).length === 0) {
    return;
  }

  const slideIndex = getSlideIndex(state);
  const deck = getDeckByComponentId(state, {id});

  activeSlideIndex = deck.slide_order.indexOf(component.slide_id);

  if (activeSlideIndex !== slideIndex) {
    debouncedSetActiveIndex();
  }
}

function onViewportEnter(entries) {
  if (!entries) {
    return;
  }

  const intersectingEntries = entries.filter(isIntersecting);

  intersectingEntries.forEach(callEntry);

  const entry = intersectingEntries.reduce(mostIntersecting, initialEntry);

  if (entry !== initialEntry) {
    syncSlideIndex(entry);
  }
}

const observer = new IntersectionObserver(onViewportEnter, {
  root: null,
  rootMargin: '0px',
  threshold: 0.2
});

export function observe(el, callback) {
  callbacks.set(el, callback);
  observer.observe(el);
}
